export enum CacheKey {
    appOption = 'app-options',
}
